const dispatchType = (sourceName, type) =>
  ['DATA_LIST', sourceName.toUpperCase(), type].filter(Boolean).join('/');

export default dispatchType;
